<h5> نام و آدرس مشتری گواهی نامه </h5>


<div class="row">

  <div class="form-group col-md-6">
    <label for="exampleInputEmail1">آدرس گواهی نامه</label>
    <select [(ngModel)]="Seletected_Certificate_Address" class="custom-select">
      <option value="">آدرس ثبت شده در نامه</option>
      <option *ngFor="let item of DataList_Address" [value]="item">{{item}}</option>
    </select>
  </div>
  <div class="form-group col-md-6">
    <label for="exampleInputEmail1">نام مشتری گواهی نامه</label>
    <select [(ngModel)]="Seletected_Certificate_Name" class="custom-select">
      <option value="">نام ثبت شده در نامه</option>
      <option *ngFor="let item of DataList_Name" [value]="item">{{item}}</option>
    </select>
  </div>
</div>

<button type="button" (click)="SubmitAddressLetter()" class="btn btn-success" style="margin-left: 5px;"><i class="fa fa-check"></i> ثبت آدرس گواهی نامه </button>

